// extracted by mini-css-extract-plugin
export var closeButton = "_13-5";
export var container = "_13-0";
export var contentContainer = "_13-1";
export var desktop = "_13-2";
export var fullModalImage = "_13-6";
export var mobile = "_13-3";
export var withImage = "_13-4";